import React from "react";

// The marks a version row draws on the versions rail (#11956): a 1px line
// down the family's rows, from the first row's node to the last row's, an
// 8px node on a revision's row, and for a copy a 12px stub off the rail to a
// 6px node. The open document's node is filled; every other node is hollow.
// The Versions section in Details and the documents grid's Versions column
// (#13682) both draw them, so a family reads the same in both places.
//
// The host is `position: relative` and puts its text clear of the marks:
// 22px for a revision's row, 32px for a copy's. `center` is where the node
// sits from the top of the host and where the rail starts on the first row
// and ends on the last.
export const VersionMarks: React.FC<{
  isCopy: boolean;
  isFirst: boolean;
  isLast: boolean;
  filled: boolean;
  center: string;
}> = ({ isCopy, isFirst, isLast, filled, center }) => {
  const node = filled
    ? "bg-gray-900 border-[1.5px] border-gray-900"
    : "bg-white border-[1.5px] border-gray-400";
  return (
    <>
      <span
        aria-hidden
        className="absolute left-[3.5px] w-px bg-gray-300"
        style={{
          top: isFirst ? center : 0,
          ...(isLast ? { height: center } : { bottom: 0 }),
        }}
      />
      {isCopy ? (
        <>
          <span
            aria-hidden
            className="absolute left-1 w-3 h-px bg-gray-300"
            style={{ top: center }}
          />
          <span
            aria-hidden
            className={`absolute left-4 -mt-[3px] w-1.5 h-1.5 rounded-full box-border ${node}`}
            style={{ top: center }}
          />
        </>
      ) : (
        <span
          aria-hidden
          className={`absolute left-0 -mt-1 w-2 h-2 rounded-full box-border ${node}`}
          style={{ top: center }}
        />
      )}
    </>
  );
};
